
import { defineComponent, ref, watch } from 'vue'
import { ValidationProvider } from 'vee-validate'
import { translateError } from '@/filters'
import { IdfStandardInputs } from '@invivodf/ui-kit'

export default defineComponent({
  name: 'CInput',
  emit: ['input'],
  components: { ValidationProvider, IdfStandardInputs },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    formErrors: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    rules: String,
  },
  setup(props, context) {
    const inputValue = ref(props.value)
    const validationInput = ref(null)

    watch(
      () => props.formErrors,
      (newValue: string[]) => {
        // @ts-ignore EXPLIQUER POURQUOI CE TS IGNORE
        validationInput.value?.setErrors(newValue)
      },
    )

    watch(
      () => props.value,
      (newValue: string) => {
        inputValue.value = newValue
      },
    )

    function updateValue() {
      context.emit('input', inputValue.value)
    }

    return { inputValue, translateError, updateValue, validationInput }
  },
})
